import styles from 'components/__SHARED__/AssembleiaPautasNew/styles.module.scss';

export const STATUS_PAUTA_BLOQUEADA = 0;
export const STATUS_PAUTA_LIBERADA = 1;
export const STATUS_PAUTA_ENCERRADA = 2;

export const getStatusClassName = (status: number = STATUS_PAUTA_BLOQUEADA) => {
  switch (status) {
    case STATUS_PAUTA_ENCERRADA:
      return styles.encerrada;
    case STATUS_PAUTA_LIBERADA:
      return styles.liberada;
    case STATUS_PAUTA_BLOQUEADA:
    default:
      return styles.bloqueada;
  }
};

export const getStatusName = (status: number = STATUS_PAUTA_BLOQUEADA) => {
  switch (status) {
    case STATUS_PAUTA_ENCERRADA:
      return 'Encerrada';
    case STATUS_PAUTA_LIBERADA:
      return 'Liberada';
    case STATUS_PAUTA_BLOQUEADA:
    default:
      return 'Bloqueada';
  }
};

export const STATUS_PAUTA = [
  STATUS_PAUTA_BLOQUEADA,
  STATUS_PAUTA_LIBERADA,
  STATUS_PAUTA_ENCERRADA,
] as const;

export type PautaStatusType = (typeof STATUS_PAUTA)[number];
